import axios from 'axios';

export default {
    watch: {
        'itemCodeModal.show'(val) {
            if (val) {
                this.$refs.itemCodeFormRef.resetFields();
                Object.assign(this.itemCodeModal, {
                    tableData: [],
                    total: 0,
                    page: 1,
                    row: null,
                });
            }
        },
    },
    data() {
        return {
            itemCodeModal: {
                show: false,
                loading: false,
                type: 'form',
                form: {
                    itemCode: '',
                    itemDesc: '',
                },
                row: null,
                rowIndex: null,
                columns: [
                    {
                        title: this.$t('gscInvoice.t50'), // 物料编码
                        key: 'itemCode',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('gscInvoice.t51'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('gscInvoice.t52'), // 单位
                        key: 'itemUnit',
                        minWidth: 60,
                        align: 'center',
                    },
                ],
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            INT_CURRENCY: [],
            INT_COMMERCIAL_INVOICE_STATUS: [],
        };
    },
    methods: {
        getItemList() {
            const { pageIndex, pageSize, form, type } = this.itemCodeModal;
            const { organizationCode } = type === 'form' ? this.getFormVals : this.invoiceForm;
            this.itemCodeModal.loading = true;
            axios.post('/gscint/item/list', {
                organizationCode,
                pageIndex,
                pageSize,
                ...form,
                vendorCode: this.vendorCode,
            })
                .then((res) => {
                    const { list: tableData, total } = res.data.data?.data;
                    Object.assign(this.itemCodeModal, {
                        tableData,
                        total,
                    });
                })
                .finally(() => {
                    this.itemCodeModal.loading = false;
                });
        },
        formOptioSet(key, list) {
            if (this.formData?.items) {
                this.getFormDataItemObj(this.formData.items, key).options.values = list;
            }
        },
        itemCodeRowClick(row) {
            this.itemCodeModal.row = row;
        },
        itemCodeOnPageChange(pageIndex) {
            this.itemCodeModal.pageIndex = pageIndex;
            this.getItemList();
        },
        itemCodeOnConfirm() {
            const { type, row, rowIndex } = this.itemCodeModal;
            if (type === 'form') {
                this.getFormDataItemObj(this.formData.items, 'itemCode').value = row.itemCode;
            } else {
                const { itemCode, itemDesc } = row;
                Object.assign(this.linesMod.tableData[rowIndex], {
                    itemCode,
                    itemDesc,
                });
                this.itemCodeCount();
            }
            this.itemCodeModal.show = false;
            if (this.queryFabricationFee) {
                this.queryFabricationFee([row.itemCode]);
            }
        },
    },
    mounted() {
        /* 币种 */
        this.getDict('INT_CURRENCY', (data) => {
            this.formOptioSet('currency', data);
        });
        /* 状态 */
        this.getDict('INT_COMMERCIAL_INVOICE_STATUS', (data) => {
            this.formOptioSet('vendorStatus', data);
        });
        this.getSRMInvLovListNew((data) => {
            this.orgList = data.map(({ organizationCode: value, organizationName: label }) => {
                return {
                    value,
                    label,
                };
            });
            const org = this.formData && this.getFormDataItemObj(this.formData.items, 'organizationCode');
            if (org) {
                org.options.values = this.orgList;
            }
        });
    },
};
